import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, ComponentSync, LL_H_C, LL_V_L, ModuleFE_MouseInteractivity, mouseInteractivity_PopUp, stopPropagation } from '@nu-art/thunderstorm-frontend/index';
import './Renderer_SearchResult.scss';
import { dispatch_searchResultSelected } from '../../modules/search/index.js';
import { ModuleFE_CollectionActions } from '@nu-art/thunderstorm-frontend/modules/ModuleFE_CollectionActions';
import { ModuleFE_ConflictResolution } from '@nu-art/conflict-resolution-frontend/_modules/ModuleFE_ConflictResolution';
export class Renderer_SearchResult extends ComponentSync {
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state.selected = nextProps.selected ?? false;
        return state;
    }
    // ######################## Logic ########################
    getClassName = () => {
        return _className('search-result', this.state.selected && 'selected', this.props.error && 'error', this.props.className);
    };
    onRightClick = (e) => {
        const actions = [
            { actionLabel: 'Show Usage', actionCallback: this.onRightClick_ShowUsage },
            ...(this.props.getRightClickActions?.(this.props.itemKey, this.props.itemId) ?? [])
        ];
        const model = {
            id: 'search-result__context-menu',
            modalPos: { x: 1, y: 1 },
            originPos: { x: e.clientX, y: e.clientY },
            content: () => {
                return _jsx(LL_V_L, { children: actions.map(action => _jsx(Button, { onClick: () => {
                            action.actionCallback();
                            ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                        }, children: action.actionLabel }, action.actionLabel)) });
            }
        };
        ModuleFE_MouseInteractivity.showContent(model);
    };
    onRightClick_ShowUsage = async () => {
        const response = await ModuleFE_CollectionActions.check.usage({
            itemIds: [this.props.itemId],
            dbKey: this.props.itemKey,
        }).executeSync();
        ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
        if (response.dependencies)
            ModuleFE_ConflictResolution.showDependencies(response.dependencies);
    };
    // ######################## Render ########################
    renderItemData = () => {
        const { hierarchy, tags, entityLabel } = this.props;
        return _jsxs(LL_V_L, { style: { gap: '10px' }, children: [_jsxs(LL_H_C, { className: 'search-result__data', children: [!!entityLabel &&
                            _jsx("div", { className: 'search-result__type', children: entityLabel }), !!entityLabel && !!hierarchy && 'in', !!hierarchy &&
                            _jsx("div", { className: 'search-result__hierarchy', children: hierarchy })] }), _jsx(LL_H_C, { className: 'search-result__data', children: !!tags && (tags.map(tag => (_jsx("div", { className: _className('search-result__hierarchy', tag.className), children: tag.label }, tag.label)))) })] });
    };
    orgRendererContainer = () => {
        if (!this.props.orgRenderer)
            return;
        return _jsx("div", { className: 'org-renderer-container', children: this.props.orgRenderer });
    };
    renderItemLabel = () => {
        return _jsxs(LL_H_C, { className: 'search-result__item', children: [this.props.itemLabel, this.props.labelIcon] });
    };
    render() {
        return _jsxs(LL_V_L, { className: this.getClassName(), style: this.props.style, onContextMenu: this.onRightClick, onClick: e => {
                stopPropagation(e);
                this.props.onClickCallback?.();
                dispatch_searchResultSelected.dispatchUI(this.props.itemId, this.props.itemKey);
            }, children: [this.orgRendererContainer(), this.renderItemLabel(), this.renderItemData()] });
    }
}
//# sourceMappingURL=Renderer_SearchResult.js.map